import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";

let companyEdit = () => import(/* webpackChunkName: "company" */ '@/views/company/Edit');

let companyService = () => import(/* webpackChunkName: "service" */ '@/views/company/service/Index');
let companyCertificate = () => import(/* webpackChunkName: "certificate" */ '@/views/company/certificate/Index');
let newsIndex = () => import(/* webpackChunkName: "project" */ '@/views/company/news/Index');
let newsEdit = () => import(/* webpackChunkName: "project" */ '@/views/company/news/Edit');
let newsCreate = () => import(/* webpackChunkName: "project" */ '@/views/company/news/Create');

 export default [

        {
            path: "/services",
            name: "services.index",
            component: companyService,
            meta: {
                middleware: web,
                title: "خدمات شرکت"
            }
        },
        {
            path: "/certificates",
            name: "certificate.index",
            component: companyCertificate,
            meta: {
                middleware: web,
                title: "گواهینامه شرکت"
            }
        },

        {
            path: "/news",
            name: "news.index",
            component: newsIndex,
            meta: {
                middleware: web,
                title: "اخبار شرکت"
            }
        },
        {
            path: "/news/:id",
            name: "news.edit",
            component: newsEdit,
            meta: {
                middleware: web,
                title: " جزئیات اخبار"
            }
        },
        {
            path: "/news/create",
            name: "news.create",
            component: newsCreate,
            meta: {
                middleware: web,
                title: " ایجاد خبر"
            }
        },
     {
            path: "/company/create",
            name: "company.edit",
            component: companyEdit,
            meta: {
                middleware: web,
                title: "جزئیات شرکت"
            }
        },

]